import { getStudentLiveTypeList } from '../api/modules/department'

/**
 * 规范化人员类型列表。最后更新：2026-10-16
 * @param {Array} raw
 * @returns {Array<{LiveTypeId: string, LiveTypeName: string, DefaultLiveTypeName: string, SchId: string, IsDefault: boolean}>}
 */
export function normalizeLiveTypeList(raw) {
  const list = Array.isArray(raw) ? raw : []
  return list.map((item) => {
    const schId = String(item.SchId || item.schId || '').trim()
    const hasIsDefaultFlag = item.IsDefault != null || item.isDefault != null
    return {
      LiveTypeId: item.LiveTypeId || item.liveTypeId || '',
      LiveTypeName: item.LiveTypeName || item.liveTypeName || '',
      DefaultLiveTypeName: item.DefaultLiveTypeName || item.defaultLiveTypeName || '',
      SchId: schId,
      // GetStudentLiveType 用 SchId 空表示默认；GetStudentLiveTypeBySchId 带 IsDefault
      IsDefault: hasIsDefaultFlag ? !!(item.IsDefault || item.isDefault) : !schId
    }
  }).filter((x) => x.LiveTypeId)
}

/**
 * 按部门加载本校有效人员类型。最后更新：2026-09-15
 * @param {string|number} departmentId
 */
export async function fetchStudentLiveTypesByDeptId(departmentId) {
  if (!departmentId) return []
  const res = await getStudentLiveTypeList({ id: departmentId })
  return normalizeLiveTypeList(res && res.data && res.data.response)
}

/**
 * 从已加载列表解析展示名。最后更新：2026-09-15
 */
export function liveTypeNameOf(types, liveTypeId) {
  const id = String(liveTypeId || '').trim()
  if (!id) return ''
  const found = (types || []).find((t) => String(t.LiveTypeId) === id)
  return (found && found.LiveTypeName) || ''
}

/**
 * 将 searchList 中 liveTypeId 下拉改为本校名称。最后更新：2026-09-15
 */
export function applyLiveTypeFilterOptions(searchList, types) {
  const item = (searchList || []).find((x) => x.key === 'liveTypeId')
  if (!item) return
  item.options = [{ label: '全部', value: '' }].concat((types || []).map((t) => ({
    label: t.LiveTypeName || t.LiveTypeId,
    value: t.LiveTypeId
  })))
}
